"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStagingVersionedUrl = exports.getVersionedUrl = void 0;
const getVersionedUrl = (url, version, prefix = "--ver--") => {
    const urlParts = url.split('/remoteEntry.js');
    return `${urlParts[0]}${prefix}${version}/remoteEntry.js${urlParts[1]}`;
};
exports.getVersionedUrl = getVersionedUrl;
const getStagingVersionedUrl = (remoteApps, microApps, version, prefix = "--ver--") => {
    microApps.forEach((app) => {
        if (remoteApps[app]) {
            remoteApps[app] = (0, exports.getVersionedUrl)(remoteApps[app], version, prefix);
        }
    });
    return remoteApps;
};
exports.getStagingVersionedUrl = getStagingVersionedUrl;
//# sourceMappingURL=getVersionURL.js.map